import React from 'react'
import { useGlobalPresence } from '@/hooks/useGlobalPresence'

export function OnlineUsers() {
  const { onlineCount, onlineUsers, loading } = useGlobalPresence()

  // Defensive checks: ensure onlineUsers is an array
  const safeOnlineUsers = Array.isArray(onlineUsers) ? onlineUsers : []
  const safeOnlineCount = typeof onlineCount === 'number' ? onlineCount : 0

  // Show loading state briefly
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <span className="h-2 w-2 rounded-full bg-gray-400 animate-pulse" />
        <span>Loading...</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 text-sm text-gray-600">
      <span className="h-2 w-2 rounded-full bg-green-500" />
      <span>{safeOnlineCount} online</span>
      {safeOnlineUsers.length > 0 && (
        <div className="flex -space-x-2">
          {safeOnlineUsers.slice(0, 3).map(user => (
            <div key={user.user_id} className="w-6 h-6 rounded-full bg-gray-300 border-2 border-white" title={user.username}>
              {user.avatar_url && (
                <img src={user.avatar_url} alt={user.username} className="w-full h-full rounded-full object-cover" />
              )}
            </div>
          ))}
          {safeOnlineUsers.length > 3 && (
            <div className="w-6 h-6 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs">+{safeOnlineUsers.length - 3}</div>
          )}
        </div>
      )}
    </div>
  )
}


